
const initialState = {
    loading: false,
    newPass: false,
    error: false,
    totalVehicles:0,
    vehiclesListing:[],
    vehiclesDetail:null
  };
  
  const vehiclesReducer = (state = initialState, action) => {
    console.log("vehicles  reducers------", state,action);
   switch (action.type) {
     case "ADD_VEHICLES_REQUEST":
       return {
         ...state,
         loading: true,
       };
     case "ADD_VEHICLES_SUCCESS":
       return {
        ...state,
         loading: false,
         newPass: true,
         error: false,
       };
     case "ADD_VEHICLES_FAILED":
       return {
        ...state,
         loading: false,
         newPass: false,
         error: true,
       };

       case "GET_VEHICLES_REQUEST":
        return {
          ...state,
          loading: true,
        };
      case "GET_VEHICLES_REQUEST_FAILED":
        return {
          ...state,
          error: true,
        };
      case "GET_VEHICLES_REQUEST_SUCCESS":
        return {
          ...state,
          vehiclesListing: action.payload,
          totalVehicles:action.total,
          loading:false,
        };

      case "GOT_VEHICLES_DETAIL":  
      return {
        ...state,
        vehiclesDetail: action.payload,
      };
     default:
       return state;
   }
  };
  
  export default vehiclesReducer;
  